// This class currently defines only concrete maturity models
// Nonetheless, it acts as a base class for future concrete model types discrimination
// The type modelType field will be used for so
export class Concrete {
  // COMMON FIELDS
    _id?: string;
    name?: string;
    modelType?: string;
    company?: string;
    project?: string;
    concreteMixture?: string;
    isActive?: boolean;
    updatedAt?: Date;
    createdAt?: Date;

    // ConcreteMaturityModel fields
    A_VAL?: number;
    B_VAL?: number;
    ABS_TEMP?: number;
    maturityMethod?: string;
    strengthMethod?: string;
    log?: string;
    specifications?: number[];
    specifications_maturity?: number[];
    specifications_maturity_relative?: number[];
    fitStats?: {
      r2: number;
      method: string;
      calculatedAt: Date;
      calculatedBy: string;
      notes?: string;
    };
    /** The model's single calibration batch — see MaturityCalibrationSample doc. */
    calibrationTest?: MaturityCalibrationSample;

    // Other modelType specific fields will go here...
  }

/** One cleanup/derivation op applied when deriving a calibration result's final maturity point. Free-form by design — mirrors StrengthTestResult.completionLog. */
export interface MaturityCalibrationCleanupOp {
  op: string;
  params: Record<string, any>;
  appliedAt: Date;
  appliedBy: string;
}

/** One test age broken from the model's calibration batch. */
export interface MaturityCalibrationResult {
  testAge: number;
  strengthResult: number;
  measurement?: string;
  maturityAtBreak?: number;
  cleanupLog?: MaturityCalibrationCleanupOp[];
}

/**
 * The single calibration batch behind a Concrete Model's fitted A_VAL/B_VAL — one sampleDate,
 * one or more lab report files (preliminary + final, appended over time — latest is the last
 * element), and the per-age results broken from it. See ADR 0012 for why this is copied rather
 * than a live reference to StrengthTestResult.
 */
export interface MaturityCalibrationSample {
  sampleDate?: Date;
  files: string[];
  results: MaturityCalibrationResult[];
}
